import { Injectable } from '@angular/core';
import { UserApiMethod } from './../../api-methods/api-methods';
import { UrlConfig } from './../../config/url.config';
import { HttpClientService } from './../http/httpClient.service';
import { HttpHeadersService } from './../http/httpHeaders.service';

@Injectable({
  providedIn: 'any',
})
export class UserService {
  constructor(
    private _httpClientService: HttpClientService,
    private _httpHeadersService: HttpHeadersService
  ) {}

  getUserInformation(userId: number): any {
    let userBrokerAccountsUrl = `${UrlConfig.userApiBaseUrl}${UserApiMethod.GetUserInformation}`;
    userBrokerAccountsUrl = userBrokerAccountsUrl.replace(
      '{userId}',
      userId.toString()
    );
    return this._httpClientService.get<any>(
      userBrokerAccountsUrl,
      this._httpHeadersService.getUserHttpOptions()
    );
  }

  getAgencyDetails(brokerId: number): any {
    let agencyDetailsUrl = `${UrlConfig.userApiBaseUrl}${UserApiMethod.GetBrokerAgencyDetails}`;
    agencyDetailsUrl = agencyDetailsUrl.replace(
      '{brokerId}',
      brokerId.toString()
    );
    return this._httpClientService.get<any>(
      agencyDetailsUrl,
      this._httpHeadersService.getUserHttpOptions()
    );
  }

  getCarrierLogoDetails(carrierLogoRequest): any {
    let getCarrierLogoUrl = `${UrlConfig.planLiteApiBaseUrl}${UserApiMethod.GetCarrierLogo}`;
    return this._httpClientService.post<any>(
      getCarrierLogoUrl,
      carrierLogoRequest,
      this._httpHeadersService.getPlanLiteHttpOptions()
    );
  }

  getCarrierLogoFilePath(logoPath): any {
    let url = `${UrlConfig.planLiteApiBaseUrl}${UserApiMethod.LogoFilePath}`;
    url = url.replace('{*filePath}', logoPath.toString());
    return this._httpClientService.get<any>(url, {
      responseType: 'image/svg+xml; charset=utf-8',
    });
  }

  getExternalLinkDetail(id: number): any {
    let externalLinkUrl = `${UrlConfig.userApiBaseUrl}${UserApiMethod.GetExternalLinkById}`;
    externalLinkUrl = externalLinkUrl.replace('{id}', id.toString());
    return this._httpClientService.get<any>(
      externalLinkUrl,
      this._httpHeadersService.getRateTableUAHttpOptions()
    );
  }
}
